/*
  SecureNu offerte-assistent ("Jim").
  - Stelt een paar vragen, neemt de antwoorden uit de keuzehulp over en zet de benodigde
    producten met prijzen op een rij.
  - De klant kan alles in de winkelwagen zetten, de lijst kopiëren of een offerte/advies
    aanvragen via het Shopify-contactformulier.
  - Met een webhook-URL gaat de aanvraag ook als JSON naar de webhook (type "quote_request")
    en kan een AI vrije vragen beantwoorden (type "chat", antwoord { "reply": "..." }).
  - Weergave "popup": opent bij klik op een offertelink.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'securenu_keuzehulp';
  var SENT_KEY = 'securenu_offerte_sent';
  var ICONS = {
    cart: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.6 12.2a1 1 0 0 0 1 .8h9.3a1 1 0 0 0 1-.8L20.5 7H6"/></svg>',
    restart: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 3v6h-6"/></svg>'
  };

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function money(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') return window.theme.formatMoney(cents);
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function Assistant(root) {
    var configEl = root.querySelector('[data-offerte-config]');
    if (!configEl) return;
    try {
      this.cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    this.root = root;
    this.t = this.cfg.t || {};
    this.labels = this.cfg.labels || {};
    this.isPopup = this.cfg.display === 'popup';
    this.form = root.querySelector('[data-offerte]');
    this.log = root.querySelector('[data-assist-log]');
    this.scroller = root.querySelector('.sn-assist__form') || this.log;
    this.dots = root.querySelector('[data-assist-dots]');
    this.actions = root.querySelector('[data-assist-actions]');
    this.fields = root.querySelector('[data-assist-fields]');
    this.inputWrap = root.querySelector('[data-assist-input]');
    this.input = root.querySelector('[data-assist-text]');
    this.sendBtn = root.querySelector('[data-assist-send]');
    this.bodyField = root.querySelector('[data-offerte-body]');
    this.kindField = root.querySelector('[data-assist-kind]');
    this.done = root.querySelector('[data-assist-done]');
    this.started = false;
    this.onText = null;
    this.history = [];
    this.state = {};
    this.bind();
    this.restoreAfterSubmit();
    if (!this.isPopup && !this.started) this.start();
  }

  /* ---------- Opslag ---------- */

  Assistant.prototype.readStored = function () {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : null;
      return data && data.answers && data.answers.equip ? data : null;
    } catch (e) {
      return null;
    }
  };

  // Na versturen laadt Shopify de pagina opnieuw. Alleen het formulier dat echt verstuurd is,
  // toont dan de bevestiging of de foutmelding.
  Assistant.prototype.restoreAfterSubmit = function () {
    var sentHere = false;
    try {
      sentHere = sessionStorage.getItem(SENT_KEY) === this.cfg.display;
      if (sentHere) sessionStorage.removeItem(SENT_KEY);
    } catch (e) { /* geen opslag */ }
    var errors = this.root.querySelector('[data-assist-errors]');

    if (this.done && (sentHere || !this.isPopup)) {
      this.started = true;
      this.log.hidden = true;
      this.setDots(0, 0);
      this.setActions([{ label: this.labels.restart, style: 'dark', icon: 'restart', onClick: this.restart.bind(this) }]);
      if (this.isPopup) this.open();
      return;
    }
    if (this.done) this.done.remove();
    if (errors && (sentHere || !this.isPopup)) {
      this.started = true;
      this.state = {};
      this.say(this.t.form_intro_quote);
      this.fields.hidden = false;
      this.setActions([{ label: this.labels.restart, style: 'dark', icon: 'restart', onClick: this.restart.bind(this) }]);
      if (this.isPopup) this.open();
    } else if (errors) {
      errors.remove();
    }
  };

  /* ---------- Gebeurtenissen ---------- */

  Assistant.prototype.bind = function () {
    var self = this;
    function submitText() {
      var value = self.input.value.trim();
      if (!value || !self.onText) return;
      self.input.value = '';
      self.onText(value);
    }
    if (this.sendBtn) this.sendBtn.addEventListener('click', submitText);
    if (this.input) {
      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitText();
        }
      });
    }

    this.form.addEventListener('submit', function (event) {
      if (self.bodyField) self.bodyField.value = self.quoteText();
      try { sessionStorage.setItem(SENT_KEY, self.cfg.display); } catch (e) { /* geen opslag */ }
      if (self.form.dataset.sent === 'true' || !self.cfg.webhook) return;
      event.preventDefault();
      var submitter = event.submitter || self.form.querySelector('[data-offerte-submit]');
      if (submitter) submitter.disabled = true;
      var finish = function () {
        self.form.dataset.sent = 'true';
        if (submitter) submitter.disabled = false;
        if (self.form.requestSubmit) self.form.requestSubmit(submitter || undefined);
        else self.form.submit();
      };
      var timeout = new Promise(function (resolve) { setTimeout(resolve, 4000); });
      Promise.race([self.post(self.payload('quote_request')), timeout]).then(finish, finish);
    });

    if (this.isPopup) {
      this.root.querySelectorAll('[data-assist-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !self.root.hidden) self.close();
      });
      var triggers = String(this.cfg.triggers || '').split(',').map(function (s) {
        return s.trim().replace(/\/$/, '');
      }).filter(Boolean);
      document.addEventListener('click', function (event) {
        var target = event.target.closest('a, [data-open-offerte]');
        if (!target || self.root.contains(target)) return;
        var match = target.hasAttribute('data-open-offerte');
        if (!match && target.tagName === 'A' && target.href) {
          var url = new URL(target.href, window.location.href);
          if (url.origin === window.location.origin) {
            match = triggers.indexOf(url.pathname.replace(/\/$/, '')) !== -1 ||
              (url.hash === '#offerte' && url.pathname === window.location.pathname);
          }
        }
        if (!match) return;
        event.preventDefault();
        self.open(target);
      });
    }
  };

  Assistant.prototype.open = function (opener) {
    this.opener = opener || null;
    this.root.hidden = false;
    document.documentElement.classList.add('sn-assist-open');
    if (!this.started) this.start();
    var close = this.root.querySelector('.sn-assist__close');
    if (close) close.focus({ preventScroll: true });
  };

  Assistant.prototype.close = function () {
    this.root.hidden = true;
    document.documentElement.classList.remove('sn-assist-open');
    if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
  };

  /* ---------- Webhook ---------- */

  Assistant.prototype.post = function (data) {
    return fetch(this.cfg.webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      keepalive: true
    });
  };

  Assistant.prototype.contact = function () {
    var out = {};
    this.form.querySelectorAll('input[name^="contact["]').forEach(function (field) {
      var key = field.name.replace(/^contact\[/, '').replace(/\]$/, '');
      if (field.value) out[key] = field.value;
    });
    return out;
  };

  Assistant.prototype.payload = function (type, message) {
    var q = this.quote;
    return {
      type: type,
      shop: this.cfg.shop,
      page: window.location.href,
      message: message || '',
      contact: type === 'quote_request' ? this.contact() : {},
      answers: this.state || {},
      keuzehulp: this.state && this.state.useStored && this.stored ? this.stored.lines : [],
      quote: q ? { currency: this.cfg.currency, lines: q.lines, installation: q.installation, remoteConfig: !!q.remoteConfig, total: q.total, custom: q.custom } : null,
      quoteText: this.quoteText(),
      history: this.history || []
    };
  };

  /* ---------- Chatvenster ---------- */

  Assistant.prototype.scroll = function () {
    this.scroller.scrollTop = this.scroller.scrollHeight;
  };

  Assistant.prototype.say = function (text, who) {
    var msg = el('div', 'sn-msg sn-msg--' + (who || 'bot'), text);
    this.log.appendChild(msg);
    this.history.push({ role: who === 'user' ? 'user' : 'assistant', text: text });
    this.scroll();
    return msg;
  };

  Assistant.prototype.setDots = function (done, total) {
    if (!this.dots) return;
    this.dots.textContent = '';
    for (var i = 0; i < total; i++) {
      this.dots.appendChild(el('span', 'sn-assist__dot' + (i < done ? ' is-done' : '')));
    }
  };

  // Knoppen onderin. style: 'option' (gestippeld), 'primary' (blauw), 'dark' (breed, donker).
  Assistant.prototype.setActions = function (items) {
    var self = this;
    this.actions.textContent = '';
    (items || []).forEach(function (item) {
      var node;
      if (item.href) {
        node = el('a', 'sn-btn sn-btn--' + (item.style || 'option'));
        node.href = item.href;
      } else {
        node = el('button', 'sn-btn sn-btn--' + (item.style || 'option'));
        node.type = 'button';
      }
      if (item.icon) {
        var icon = el('span', 'sn-btn__icon');
        icon.innerHTML = ICONS[item.icon] || '';
        node.appendChild(icon);
      }
      node.appendChild(document.createTextNode(item.label));
      if (item.onClick) {
        node.addEventListener('click', function () { item.onClick(node); });
      }
      self.actions.appendChild(node);
    });
  };

  Assistant.prototype.setInput = function (handler) {
    this.onText = handler;
    if (this.inputWrap) this.inputWrap.hidden = !handler;
  };

  Assistant.prototype.ask = function (text, options, onPick) {
    var self = this;
    this.say(text);
    this.setActions(options.map(function (option) {
      return {
        label: option.label,
        style: 'option',
        onClick: function () {
          self.setActions([]);
          self.say(option.label, 'user');
          onPick(option);
        }
      };
    }));
  };

  /* ---------- Vragen ---------- */

  Assistant.prototype.steps = function () {
    var s = this.state;
    var list = ['equip', 'building'];
    if (!s.equip || s.equip === 'camera' || s.equip === 'all') list.push('qty');
    list.push('install', 'notes');
    return list;
  };

  Assistant.prototype.updateDots = function () {
    var s = this.state;
    var list = this.steps();
    var done = list.filter(function (key) { return key === 'notes' ? s.notes != null : s[key] != null; }).length;
    this.setDots(done, list.length);
  };

  Assistant.prototype.restart = function () {
    if (this.done) {
      this.done.remove();
      this.done = null;
    }
    this.log.hidden = false;
    this.start();
  };

  Assistant.prototype.start = function () {
    var self = this;
    var t = this.t;
    this.started = true;
    this.state = {};
    this.quote = null;
    this.history = [];
    this.stored = this.readStored();
    this.log.textContent = '';
    this.fields.hidden = true;
    this.setInput(null);
    this.updateDots();
    if (this.cfg.welcome) this.say(this.cfg.welcome);

    if (this.stored) {
      this.ask(t.found_answers + ' ' + this.stored.summary + '. ' + t.use_question, [
        { id: 'yes', label: t.yes_use },
        { id: 'no', label: t.no_restart }
      ], function (option) {
        if (option.id === 'yes') {
          var a = self.stored.answers;
          self.state.useStored = true;
          self.state.equip = a.equip;
          self.state.building = a.building;
          if (a.install === 'zelf') self.state.install = 'self';
          if (a.install === 'vakman') self.state.install = 'partner';
        } else {
          self.stored = null;
        }
        self.next();
      });
    } else {
      this.next();
    }
  };

  Assistant.prototype.next = function () {
    var self = this;
    var t = this.t;
    var s = this.state;
    this.updateDots();

    if (!s.equip) {
      return this.ask(t.q_equip, [
        { id: 'alarm', label: t.equip_alarm },
        { id: 'camera', label: t.equip_camera },
        { id: 'access', label: t.equip_access },
        { id: 'all', label: t.equip_all }
      ], function (o) { s.equip = o.id; self.next(); });
    }
    if (!s.building) {
      return this.ask(t.q_building, [
        { id: 'woning', label: t.b_woning },
        { id: 'appartement', label: t.b_appartement },
        { id: 'bedrijf', label: t.b_bedrijf },
        { id: 'vakantie', label: t.b_vakantie }
      ], function (o) { s.building = o.id; self.next(); });
    }
    if (!s.qty && (s.equip === 'camera' || s.equip === 'all')) {
      return this.ask(t.q_qty, [1, 2, 3, 4, 6, 8].map(function (n) {
        return { id: n, label: String(n) };
      }), function (o) { s.qty = o.id; self.next(); });
    }
    if (!s.install) {
      return this.ask(t.q_install, [
        { id: 'self', label: t.install_self },
        { id: 'partner', label: t.install_partner }
      ], function (o) { s.install = o.id; self.next(); });
    }
    if (s.notes == null) {
      this.say(t.q_notes);
      this.setActions([{
        label: t.skip,
        style: 'option',
        onClick: function () {
          s.notes = '';
          self.setInput(null);
          self.next();
        }
      }]);
      this.setInput(function (value) {
        self.say(value, 'user');
        s.notes = value;
        self.setInput(null);
        self.next();
      });
      return;
    }
    this.showResult();
  };

  /* ---------- Uitkomst ---------- */

  Assistant.prototype.pickProducts = function () {
    var s = this.state;
    if (s.useStored && this.stored && this.stored.products && this.stored.products.length) {
      return this.stored.products.map(function (p) {
        return { title: p.title, price: p.price, url: p.url, variantId: p.variantId || null, category: p.kind === 'doorbell' || p.kind === 'intercom' ? 'access' : p.kind };
      });
    }
    var byCategory = {};
    this.cfg.products.forEach(function (p) {
      if (!byCategory[p.category]) byCategory[p.category] = p;
    });
    var wanted = s.equip === 'all' ? ['alarm', 'camera', 'access'] : [s.equip];
    return wanted.map(function (category) { return byCategory[category]; }).filter(Boolean);
  };

  Assistant.prototype.buildQuote = function () {
    var s = this.state;
    var cfg = this.cfg;
    var products = this.pickProducts();
    var custom = s.building === 'bedrijf' || products.length === 0 || (s.useStored && this.stored && this.stored.adviceReason);
    if (custom) return { custom: true, lines: [], installation: null, total: null, unpriced: false };

    var cameras = s.qty || 1;
    var lines = [];
    if (s.equip === 'all') {
      products.forEach(function (p) {
        lines.push({ title: p.title, url: p.url, variantId: p.variantId, quantity: p.category === 'camera' ? cameras : 1, price: p.price });
      });
    } else {
      var main = products[0];
      lines.push({ title: main.title, url: main.url, variantId: main.variantId, quantity: s.equip === 'camera' ? cameras : 1, price: main.price });
    }
    (cfg.extras || []).forEach(function (x) {
      if (s.equip !== 'all' && x.category !== s.equip) return;
      lines.push({ title: x.title, url: x.url, variantId: x.variantId, quantity: x.perUnit ? cameras : 1, price: x.price });
    });

    var total = 0;
    var units = 0;
    var unpriced = false;
    lines.forEach(function (line) {
      if (line.price == null) {
        line.lineTotal = null;
        unpriced = true;
        return;
      }
      line.lineTotal = line.price * line.quantity;
      total += line.lineTotal;
    });
    lines.slice(0, s.equip === 'all' ? products.length : 1).forEach(function (line) { units += line.quantity; });
    var installation = null;
    if (s.install === 'partner') {
      installation = cfg.installCents > 0 ? cfg.installCents * units : 0;
      total += installation;
    }
    return { custom: false, lines: lines, installation: installation, total: total, unpriced: unpriced, remoteConfig: this.hasPackage(lines) };
  };

  // Een pakket (zie Thema-instellingen > Pakketten) krijgt gratis configuratie op afstand.
  Assistant.prototype.hasPackage = function (lines) {
    var handles = this.cfg.packageHandles || [];
    return lines.some(function (line) {
      if (!line.url || line.url.indexOf('/products/') === -1) return false;
      var handle = line.url.split('/products/')[1].split(/[?#\/]/)[0];
      return handles.indexOf(handle) !== -1;
    });
  };

  Assistant.prototype.showResult = function () {
    var self = this;
    var t = this.t;
    var L = this.labels;
    this.quote = this.buildQuote();
    var q = this.quote;
    this.updateDots();

    if (q.custom) {
      this.say(t.quote_custom);
    } else {
      var card = el('div', 'sn-msg sn-msg--bot sn-quote');
      card.appendChild(el('div', 'sn-quote__intro', L.resultIntro));
      var table = el('table', 'sn-quote__table');
      q.lines.forEach(function (line) {
        var row = el('tr');
        row.appendChild(el('td', 'sn-quote__qty', line.quantity + '×'));
        var name = el('td', 'sn-quote__name');
        if (line.url) {
          var a = el('a', '', line.title);
          a.href = line.url;
          name.appendChild(a);
        } else {
          name.textContent = line.title;
        }
        row.appendChild(name);
        row.appendChild(el('td', 'sn-quote__price' + (line.lineTotal == null ? ' is-muted' : ''), line.lineTotal == null ? t.see_shop : money(line.lineTotal)));
        table.appendChild(row);
      });
      if (q.remoteConfig) {
        var remoteRow = el('tr');
        remoteRow.appendChild(el('td', 'sn-quote__qty', ''));
        remoteRow.appendChild(el('td', 'sn-quote__name', t.remote_line));
        remoteRow.appendChild(el('td', 'sn-quote__price is-free', t.free));
        table.appendChild(remoteRow);
      }
      if (q.installation != null) {
        var installRow = el('tr');
        installRow.appendChild(el('td', 'sn-quote__qty', ''));
        installRow.appendChild(el('td', 'sn-quote__name', t.quote_install));
        installRow.appendChild(el('td', 'sn-quote__price' + (q.installation > 0 ? '' : ' is-muted'), q.installation > 0 ? money(q.installation) : t.on_request));
        table.appendChild(installRow);
      }
      var totalRow = el('tr', 'sn-quote__total');
      totalRow.appendChild(el('td', '', ''));
      totalRow.appendChild(el('td', '', t.quote_total));
      totalRow.appendChild(el('td', 'sn-quote__price', money(q.total)));
      table.appendChild(totalRow);
      card.appendChild(table);
      if (q.unpriced) card.appendChild(el('div', 'sn-quote__note', t.total_note));
      this.log.appendChild(card);
      this.history.push({ role: 'assistant', text: L.resultIntro });
      this.scroller.scrollTop = card.offsetTop - this.scroller.offsetTop - 8;
    }
    if (this.bodyField) this.bodyField.value = this.quoteText();
    this.resultActions();

    if (this.cfg.webhook && this.cfg.aiChat) {
      this.setInput(function (value) { self.askAi(value); });
    }
  };

  Assistant.prototype.resultActions = function () {
    var self = this;
    var t = this.t;
    var L = this.labels;
    var q = this.quote;
    var s = this.state;
    var items = [];
    var cartable = q && !q.custom && q.lines.some(function (line) { return line.variantId || (line.url && line.url.indexOf('/products/') !== -1); });
    if (cartable && L.cart) {
      items.push({ label: L.cart, style: 'primary', icon: 'cart', onClick: function (btn) { self.addToCart(btn); } });
    }
    var browse = (this.cfg.browse || {})[s.equip];
    if (browse) items.push({ label: t['browse_' + s.equip], style: 'option', href: browse });
    if (q && !q.custom && L.copy) items.push({ label: L.copy, style: 'option', onClick: function () { self.copyList(); } });
    if (L.quote && q && !q.custom) items.push({ label: L.quote, style: 'option', onClick: function () { self.showForm('quote'); } });
    if (L.advice) items.push({ label: L.advice, style: 'option', onClick: function () { self.showForm('advice'); } });
    if (L.restart) items.push({ label: L.restart, style: 'dark', icon: 'restart', onClick: function () { self.start(); } });
    this.setActions(items);
  };

  Assistant.prototype.showForm = function (kind) {
    var self = this;
    var t = this.t;
    this.say(kind === 'advice' ? t.form_intro_advice : t.form_intro_quote);
    if (this.kindField) this.kindField.value = kind === 'advice' ? this.labels.advice : this.labels.quote;
    if (this.bodyField) this.bodyField.value = this.quoteText();
    this.fields.hidden = false;
    this.setInput(null);
    this.setActions([
      { label: t.back_to_overview, style: 'option', onClick: function () { self.fields.hidden = true; self.resultActions(); self.scroll(); } },
      { label: this.labels.restart, style: 'dark', icon: 'restart', onClick: function () { self.start(); } }
    ]);
    var first = this.fields.querySelector('input');
    if (first) first.focus({ preventScroll: true });
    this.fields.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  // Zoekt de variant op van producten die uit de keuzehulp komen (daar staat alleen de link in).
  Assistant.prototype.resolveVariants = function () {
    var lookups = this.quote.lines.map(function (line) {
      if (line.variantId || !line.url || line.price == null || line.url.indexOf('/products/') === -1) return Promise.resolve();
      return fetch(line.url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product || !product.variants) return;
          var variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
          if (variant) line.variantId = variant.id;
        })
        .catch(function () { /* dit product blijft buiten de winkelwagen */ });
    });
    return Promise.all(lookups);
  };

  Assistant.prototype.addToCart = function (btn) {
    var self = this;
    var label = btn.lastChild.textContent;
    btn.disabled = true;
    btn.lastChild.textContent = this.t.cart_adding;
    this.resolveVariants()
      .then(function () {
        var items = self.quote.lines.filter(function (line) { return line.variantId; }).map(function (line) {
          return { id: line.variantId, quantity: line.quantity };
        });
        return fetch(self.cfg.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) { throw new Error(data.description || data.message || ''); });
        }
        window.location.href = self.cfg.cartUrl;
      })
      .catch(function (error) {
        btn.disabled = false;
        btn.lastChild.textContent = label;
        self.say(self.t.cart_error + (error.message ? ' (' + error.message + ')' : ''));
      });
  };

  Assistant.prototype.listText = function () {
    var t = this.t;
    var q = this.quote;
    var out = [t.list_title, ''];
    q.lines.forEach(function (line) {
      out.push(line.quantity + ' x ' + line.title + ': ' + (line.lineTotal == null ? t.see_shop : money(line.lineTotal)));
      if (line.url) out.push('   ' + new URL(line.url, window.location.origin).href);
    });
    if (q.remoteConfig) out.push(t.remote_line + ': ' + t.free);
    if (q.installation != null) out.push(t.quote_install + ': ' + (q.installation > 0 ? money(q.installation) : t.on_request));
    out.push('', t.quote_total + ': ' + money(q.total));
    return out.join('\n');
  };

  Assistant.prototype.copyList = function () {
    var self = this;
    var text = this.listText();
    var done = function () { self.say(self.t.copied); };
    var fail = function () { self.say(self.t.copy_failed); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fail);
    } else {
      fail();
    }
  };

  Assistant.prototype.askAi = function (message) {
    var self = this;
    var t = this.t;
    this.aiUsed = true;
    this.say(message, 'user');
    var pending = el('div', 'sn-msg sn-msg--bot sn-msg--pending', t.thinking);
    this.log.appendChild(pending);
    this.scroll();
    this.post(this.payload('chat', message))
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var reply = text;
        try {
          var data = JSON.parse(text);
          if (Array.isArray(data)) data = data[0] || {};
          reply = data.reply || data.output || data.text || data.message || '';
        } catch (e) { /* platte tekst als antwoord is ook goed */ }
        pending.remove();
        self.say(reply || t.ai_error);
        if (self.bodyField) self.bodyField.value = self.quoteText();
      })
      .catch(function () {
        pending.remove();
        self.say(t.ai_error);
      });
  };

  // De aanvraag als platte tekst: gaat mee in het contactformulier en naar de webhook.
  Assistant.prototype.quoteText = function () {
    var t = this.t;
    var s = this.state || {};
    var q = this.quote;
    var out = [t.body_intro, ''];
    var names = {
      alarm: t.equip_alarm, camera: t.equip_camera, access: t.equip_access, all: t.equip_all,
      woning: t.b_woning, appartement: t.b_appartement, bedrijf: t.b_bedrijf, vakantie: t.b_vakantie,
      self: t.install_self, partner: t.install_partner
    };
    if (s.equip) out.push(t.label_equip + ': ' + (names[s.equip] || s.equip));
    if (s.building) out.push(t.label_building + ': ' + (names[s.building] || s.building));
    if (s.qty) out.push(t.label_qty + ': ' + s.qty);
    if (s.install) out.push(t.label_install + ': ' + (names[s.install] || s.install));
    if (s.notes) out.push(t.label_notes + ': ' + s.notes);
    if (s.useStored && this.stored && this.stored.lines && this.stored.lines.length) {
      out.push('', t.label_keuzehulp + ':');
      this.stored.lines.forEach(function (line) { out.push('- ' + line.question + ' ' + line.answer); });
    }
    if (q && !q.custom) {
      out.push('', t.label_products + ':', this.listText());
    } else if (q) {
      out.push('', t.quote_custom);
    }
    if (this.aiUsed) {
      out.push('', '---');
      (this.history || []).forEach(function (m) {
        out.push((m.role === 'user' ? t.you : 'Assistent') + ': ' + m.text);
      });
    }
    return out.join('\n');
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-assist]').forEach(function (root) {
      if (root.dataset.assistReady) return;
      root.dataset.assistReady = 'true';
      new Assistant(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
